// extracted by mini-css-extract-plugin
module.exports = {"item":"toolbar-draggable-item_item__2v87U"};